export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selectedValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: this.selectedValue
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/form-select/form-select.js